// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"496":"e90bb849","700":"ccf46d37","767":"28f53413"}[chunkId] + ".chunk.css";
};